import { z } from 'zod';

export const zodUploadLinkResponseSchema = z.object({
  expiresInHr: z.number(),
  fileId: z.string().min(1),
  sasLink: z.string().min(1),
});
